import { Container, Box, CssBaseline } from "@mui/material";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import ToastHost from "../common/ToastHost";

const Layout = () => (
  <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
    <CssBaseline />
    <Header />
    <Container component="main" disableGutters sx={{ flex: 1, py: 3 }}>
      <Box sx={{ px: { xs: 2, sm: 3 } }}>
        <Outlet />
        <ToastHost />
      </Box>
    </Container>
    <Footer />
  </Box>
);

export default Layout;
